// extracted by mini-css-extract-plugin
export default {"servicesBlock":"FreeServices_servicesBlock__z9UOd","imgBlock_left":"FreeServices_imgBlock_left__mACn3"};